import { faUsers } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import Authentication from "@yodlee/common-components/dist/types/interfaces/authentication";
import { ManageGroups as ManageGroupWidget } from "@yodlee/ycc-settings-widget";
import { Button, Drawer, Icon } from "antd";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { LabelConfigs } from "../configurations";
import { AmplitudeEventsUtils } from "../utilities";

interface IProps {
    authentication: Authentication,
    disabled: boolean,
    showButton?: boolean,
    onOpen?: () => void,
    visible?: boolean,
    onClose?: () => void
}

const ManageGroup: React.FC<IProps> = ({ authentication, disabled, showButton = true, onOpen, visible: externalVisible, onClose: externalOnClose }) => {
    const [internalVisible, setInternalVisible] = useState(false);

    let isMD = useMediaQuery({ minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD });

    const visible = externalVisible !== undefined ? externalVisible : internalVisible;

    const handleOpen = () => {
        if (externalVisible === undefined) {
            setInternalVisible(true);
        }
        if (onOpen) {
            onOpen();
        } else {
            AmplitudeEventsUtils.supportGroupsClick();
        }
    };

    const handleClose = () => {
        if (externalVisible === undefined) {
            setInternalVisible(false);
        }
        if (externalOnClose) {
            externalOnClose();
        }
    };

    const manageGroupModal =
        <Drawer
            width="85vw"
            title="Support group"
            visible={visible}
            onClose={handleClose}
            placement="right"
            className="no-padding-drawer drawer-type-1"
        >
            <ManageGroupWidget authentication={authentication} onCloseClick={handleClose} />
        </Drawer>

    return (
        <React.Fragment>
            {manageGroupModal}
            {showButton && (
                <Button disabled={disabled} type="default"
                    onClick={handleOpen}>
                    <Icon className="font-size-lg" component={() => <FontAwesomeIcon icon={faUsers} />} /> {LabelConfigs.SUPPORT_GROUPS}
                </Button>
            )}
        </React.Fragment>
    )
}

export default ManageGroup;